import Vue from 'vue'
import Router from 'vue-router'
import topPg from '@/components/top.vue'

const menuPg = () => import('@/components/menu.vue')
const reservePg = () => import('@/components/reserve.vue')
const accessPg = () => import('@/components/access.vue')
const albumPg = () => import('@/components/album.vue')
const afterPg = () => import('@/components/reserve-after.vue')
const adminPg = () => import('@/components/admin.vue')
const loginPg = () => import('@/components/login.vue')
const warnEdit = () => import('@/components/warn_edit.vue')
const menuEdit = () => import('@/components/menu_edit.vue')
const albumEdit = () => import('@/components/album_edit.vue')

Vue.use(Router)

export default new Router({
	mode: "history",
	routes: [
		{
			path: '/',
			name: 'top-page',
			component: topPg
		},
		{
			path: '/menu',
			name: 'menu-page',
			component: menuPg
		},
		{
			path: '/reserve',
			name: 'reserve-page',
			component: reservePg
		},
		{
			path: '/access',
			name: 'access-page',
			component: accessPg
		},
		{
			path: '/album',
			name: 'album-page',
			component: albumPg
		},
		{
			path: '/reserve-after',
			name: 'after-page',
			component: afterPg
		},
		{
			path: '/admin',
			component: adminPg,
			children: [
				{
					path: '',
					name: 'loginPg',
					component: loginPg
				},
				{
					path: 'warn',
					name: 'warn-edit',
					component: warnEdit,
					meta: {
						requiresAuth: true
					}
				},
				{
					path: 'menu',
					name: 'menu-edit',
					component: menuEdit,
					meta: {
						requiresAuth: true
					}
				},
				{
					path: 'album',
					name: 'album-edit',
					component: albumEdit,
					meta: {
						requiresAuth: true
					}
				}
			]
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js